import jQuery from 'jquery'

(function($) {
  "use strict";
  $(document).ready(function() {
    if ($('#companies__index').length) {
      $('.company-detail').click(function() {
        $('#modal_detail .modal-body:first').html($(this).next().html());

        var modal = document.getElementById('modal_detail');
        modal.addEventListener('hidden.bs.modal', function (event) {
          $('#modal_description .modal-body:first').text('');
        })

        var bootstrap_modal = new bootstrap.Modal(modal, {})
        bootstrap_modal.show();
      });
    }
  });

})(jQuery);
